export default __webpack_public_path__ + "static/media/blog.aeeec984.gif";